// extracted by mini-css-extract-plugin
export default {"actionicon":"ExplorerHeaderButton_actionicon__9bW0G"};